import React, { useState } from 'react'
import { Grid } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import deleteSound from './soundEffects/delete.mp3'
import useSound from 'use-sound'
import Card from './Card'
import { makeStyles } from '@material-ui/core/styles'
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Hidden from '@material-ui/core/Hidden'
import Divider from '@material-ui/core/Divider'
const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
  },
  card: {
    width: '100%',
  },
  imageContainer: {
    width: '100%',
    height: '100%',
  },
  image: {
    zIndex: 2,
    width: 200,
    height: 200,
    borderRadius: 20,
  },
  delete: {
    '&:hover': {
      cursor:'pointer',
      textDecoration: 'underline'
    }
  },
}));

const findSum = arr => {
  let sum = 0
  arr.forEach(x => sum = sum + x)
  return sum
}

export default function(props) {
  let {wishList, setWishList, setCredit} = props
  const classes = useStyles()
  const [playDelete] = useSound(deleteSound)



  const deleteItem = i => {
    let arr = [...wishList]
    let credit = arr[i].price
    arr.splice(i, 1)
    setWishList(arr)
    setCredit(x => x + credit)
    playDelete()
  }


  return(
    <div className={classes.container}>
      {wishList.map((item,i) => {
        return(
          <Grid item xs={12} key={JSON.stringify({...item, i})}>
            <ChristmasCard {...item} deleteItem={() => deleteItem(i)}/>
          </Grid>
        )
      })}
      <Grid item xs={12}>
        <p style={{fontSize: 30}}>Total: ${findSum(wishList.map(x => x.price))}</p>
      </Grid>
    </div>
  )
}


const ChristmasCard = props => {
  const classes = useStyles()
  const [showGif, setShowGif] = useState(false)
  let {name, pic, price, gif} = props
  return(
    <Grid className={classes.card} item container xs={12} justify={'center'} alignItems={'center'} alignContent={'center'} spacing={0}>
        <Grid item md={4} sm={12} xs={12} className={classes.imageContainer}>
          <img
          src={showGif && gif ? gif:pic}
          onMouseOver={() => setShowGif(true)}
          onMouseLeave={() => setShowGif(false)}
          className={classes.image}/>
        </Grid>

      <Grid item xs={10} sm={10} md={6}>
        <h3>{name}</h3>
      </Grid>
      <Hidden mdDown>
        <Grid item md={1}>
          <h3 style={{fontSize: 16}}>${price}</h3>
        </Grid>
      </Hidden>
      <Grid item xs={1}>
        <h3 className={classes.delete} onClick={props.deleteItem}><HighlightOffIcon/></h3>
      </Grid>
    </Grid>
  )
}
